import { Fragment } from 'react';

const BehavioralTab = ({ behavioralAnalysis }) => {
  return (
    <Fragment>
      <div className="behavioral-tab">{behavioralAnalysis}</div>
      <br />
    </Fragment>
  );
};

export default BehavioralTab;
